import React from 'react';
import { Table, Button, Input, Card, Modal, message, Col, Select, Popover, Form} from 'antd';
import common from '../../assets/common.js';
import moment from 'moment';
import MenuAction from '../../modest/menuaction/index.js'
import './index.css';
const Option = Select.Option;
const FormItem = Form.Item;
const defaultDate = [moment().startOf('day'),moment().endOf('day')];
class RecordTable extends React.Component {
  cancel = (id) =>{
    console.log(id)
  }
  constructor(){
    super();
    let table = {};
    table.id = "proTable";
    table = common.getDefaultTable(table);
    this.state = {
      table,
      visible: false,
      key: "",
      remark: "",
      alarmRecordId: null
    }
  }
  componentWillMount(){
    let this_ = this;
    this.showTableCol();
  }
  componentDidMount(){
    // this.getArea();
    this.getList();
  }
  showTableCol = () => {
    let table = this.state.table;
    table.columnsList = [{
      title: '报警发送时间',
      dataIndex: 'createTime',
      must: true,
      show: true,
      width: '130px'
    }, {
      title: '报警区域',
      dataIndex: 'areaName',
      must: false,
      show: true,
      width: '200px',
      render: (text, record) => (
        <span>{record.areaName}-{record.buildingName}-{record.roomName}</span>
      )
    }, {
      title: '设备编号',
      dataIndex: 'snNumber',
      must: false,
      show: true,
      width: '120px'
    }, {
      title: '离线时间',
      dataIndex: 'offlineTime',
      must: true,
      show: true,
      width : "120px"
    }, {
      title: '恢复时间',
      dataIndex: 'resumeTime',
      must: true,
      show: true,
      width : "120px"
    }, {
      title: '接收人',
      dataIndex: 'realName',
      must: true,
      show: true,
      width : "120px"
    }, {
      title: '状态',
      dataIndex: 'doorName',
      must: true,
      show: true,
      width: "120px",
      render: (text, record) => {
        let status = "";
        switch (record.status) {
          case "IN":
            status = "报警中";
            break;
          case "CLOSE_HAND":
            status = "已关闭";
            break;
          case "RESUME":
            status = "已恢复";
            break;
        }
        return (
          <span>{status}</span>
        )
      }
    },  {
      title: '备注',
      dataIndex: 'remark',
      must: true,
      show: true,
      width : "120px"
    }, {
      title: '操作',
      must: true,
      show: true,
      width : "120px",
      render: (text, record) => (
        <div>
          {record.status === "IN" && <a onClick={() => this.showClose(record)}>关闭报警</a>}
          {record.status !== "IN" && <a disabled>关闭报警</a>}
        </div>
      )
    }];
    table = common.getEcardTable(table);
    // console.log(table);
    this.setState({ table });
  }
  showClose = (record) => {
    this.setState({
      alarmRecordId: record.alarmRecordId,
      visible: true
    })
  }
  closeAlarm = () => {
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.submit(values);
      }
    })
  }
  submit = async(values) => {
    var postData = values;
    postData["_url"] = "api/alarm/record/close";
    postData["alarmRecordId"] = this.state.alarmRecordId;
    common.request(postData, this, function(obj, data){
      const result = data.result;
      obj.setState({
        visible: false
      })
      const pagination = obj.state.table.pagination;
      obj.getList(pagination.current);
      message.success("修改成功");
    },function(obj, state){
    });
  }
  changePage = (pagination, filters, sorter) => {
    const table = this.state.table;
    table.pagination = pagination;
    this.setState({ table })
    this.getList(pagination.current)
  }
  thisOk = () => {
    this.getList();
  }
  getList = async(pageInfo, filters, sorter) =>{
    var this_ = this;
    const pn = pageInfo ? pageInfo: 1;
    const table = this.state.table;
    var postData = {};
    postData["_url"] = "api/alarm/record/search";
    postData["pageNum"] = pn;
    table.loading = true;
    this.setState({ table });
    common.request(postData, this, function(obj, data){
      const result = data.result;
      obj.showList(result, pn);
    },function(obj, state){
      table.loading = false;
      obj.setState({ table });
    });
  }
  showList = (result, pn) => {
    const table = this.state.table;
    const list = result.list;
    table.loading = false;
    var dataSource = [];
    table.pagination = {
      current : pn,
      total : result.pageInfo.resultAmount,
    }
    common.eachObj(list, function(index, dataItem){
      var one = dataItem;
      one["key"] = (index + 1);
      one["orgId"] = dataItem.orgId;
      one["orgName"]= dataItem.orgName;
      one["userName"] = dataItem.userName;
      dataSource.push(one);
    })
    table.dataSource = dataSource;
    this.setState({ table });
  }
  handleCancel = ()=> {
    this.setState({
      visible: false
    });
  }
  render(){
    const { table, remark } = this.state;
    const formItemLayout = {
        labelCol: { span: 3 },
        wrapperCol: { span: 18 },
    };
    const { getFieldDecorator } = this.props.form;
    return(
      <Card>
        <div>
          <div className="table-menu clearfix">
            <div className="pull-left">
              {/*<Col span={8} style={{marginTop: 15}}>
                <Button type="primary" onClick={ this.thisOk }>查询</Button>
              </Col>*/}
            </div>
            <div className="pull-right">
            { table.show && <MenuAction obj={ this }/> }
            </div>
          </div>
          <div id="manageTableDiv" className="table-div">
            { table.show && <Table
              { ...table }
              onChange={this.changePage.bind(this)}
            />}
            <div className="table-total">共{ table.pagination.total }条数据</div>
          </div>
          <Modal
            title="关闭报警"
            visible={this.state.visible}
            onCancel={this.handleCancel}
            footer={[
              <Button type="primary" onClick={this.closeAlarm}>确定</Button>,
              <Button onClick={this.handleCancel}>关闭</Button>
            ]}
          >
            <Form>
              <FormItem {...formItemLayout}
                  label={"备注"}>
                  {getFieldDecorator('remark', {
                      rules: [{
                          required: true, message: '请填写关闭备注',
                      }],
                      initialValue: remark
                  })(
                      <Input />
                  )}
              </FormItem>
            </Form>
            <div style={{color: "#F52E38"}}>关闭本次报警后，本次报警后续通知将不再发出。</div>
          </Modal>
        </div>
      </Card>
    )
  }
}
const RecordTableForm = Form.create()(RecordTable);
export default RecordTableForm;



// WEBPACK FOOTER //
// ./src/component/devicealarm/alarmrecord.js